<template>
  <!-- 视频预览弹窗 -->
  <el-dialog
    :model-value="show"
    width="960px"
    :before-close="handleClose"
    destroy-on-close
    append-to-body
    :close-on-click-modal="false"
    :show-close="false"
    modal-class="video-preview-dialog"
  >
    <div class="preview-wrapper">
      <div class="video-list">
        <div class="video-name" 
          :class="{ 'active': activeIndex==index }" 
          v-for="(item,index) in videoList" 
          :key="item.id"
          @click="changeVideo(index)"
        >{{ item.name }}</div>
      </div>
      <div class="video-content">
        <div class="top">
          <div class="course-name">{{ videoInfo.name }}</div>
          <div class="icon-close" @click="handleClose">
            <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/463dc604f3b7401391cd2496361df06c.png"/>
          </div>
        </div>
        <div class="course-info">
          <span>{{ videoInfo.teacher }}</span>
          <span>{{ videoInfo.college }}</span>
        </div>
        <div class="video-player">
          <VideoPreview :videoUrl="videoInfo.jump_url" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import VideoPreview from './VideoPreview.vue'
import { computed, defineEmits, defineProps } from 'vue'
const props = defineProps({
  show: Boolean,
  videoList: Array,
  activeIndex: Number,
})

const emit = defineEmits(['update:show', 'update:activeIndex'])

const videoInfo = computed(() => {
  return props.videoList[props.activeIndex]
})
const handleClose = () => {
  emit('update:show', false)
}

const changeVideo = (index) => {
  emit('update:activeIndex', index)
}
</script>

<style lang="scss" scoped>
.preview-wrapper {
  height: 100%;
  display: flex;
  .video-list {
    border-radius: 12px;
    background: #F7F8FA;
    padding: 8px;
    width: 230px;
    height: 454px;
    overflow-y: scroll;
    margin-right: 12px;
    .video-name {
      height: 40px;
      border-radius: 8px;
      background: #FFF;
      margin-top: 5px;
      line-height: 40px;
      box-sizing: border-box;
      padding-left: 19px;
      color: #1C212A;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      position: relative;
      cursor: pointer;
      &.active {
        font-weight: 500;
        &::before {
          content: "";
          display: block;
          width: 3px;
          height: 16px;
          background: #0047FC;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .video-content {
    flex: 1;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .course-name {
        color: #000;
        font-family: "PingFang SC";
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
      }
      .icon-close {
        width: 24px;
        height: 24px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .course-info {
      color: #84909D;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      margin-top: 4px;
      span {
        margin-right: 8px;
      }
    }
    .video-player {
      margin-top: 12px;
    }
  } 
}
</style>

<style lang="scss">
.video-preview-dialog {
  .el-dialog {
    border-radius: 16px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 12px 20px 12px 12px;
    }
  }
} 
</style>